;(function (angular) {
  'use strict'

  angular
    .module('kilo.config')
    .config(Configuration)

  Configuration.$inject = [
    'urls',

    'EntityServiceProvider',

    'UserManagerProvider',
    'EntityManagerProvider',
    'InvoiceManagerProvider',
    'CreditNoteManagerProvider',
    'QuoteManagerProvider',
    'ProductManagerProvider',
    'ParamsManagerProvider',
    'CategoryManagerProvider',
    'CompanyParamsManagerProvider',
    'InvoiceParamsManagerProvider',
    'QuoteParamsManagerProvider',
    'CreditNoteParamsManagerProvider',
    'OrderParamsManagerProvider',
    'ProductParamsManagerProvider',
    'TagManagerProvider',
    'InvoiceTemplateManagerProvider',
    'DefaultInvoiceTemplateManagerProvider',
    'QuoteTemplateManagerProvider',
    'DefaultQuoteTemplateManagerProvider',
    'CreditNoteTemplateManagerProvider',
    'DefaultCreditNoteTemplateManagerProvider',
    'NotificationManagerProvider',
    'InmailManagerProvider',
    'BusinessContactManagerProvider',
    'BalanceManagerProvider',
    'AddressManagerProvider',
    'DashboardManagerProvider',
    'CardManagerProvider',
    'CustomFieldManagerProvider',
    'OrderManagerProvider',
    'VatManagerProvider',
    'ProductTypeManagerProvider',
    'NumberManagerProvider',
    'BpuManagerProvider',
    'InterventionManagerProvider',
    'EmailTemplateManagerProvider',
    'ChorusSettingManagerProvider',
    'ChorusMonitoringManagerProvider',
    'ChorusHistoryManagerProvider',
    'ProductPackManagerProvider'
  ]

  function Configuration (urls,
                          EntityServiceProvider,
                          UserManagerProvider,
                          EntityManagerProvider,
                          InvoiceManagerProvider,
                          CreditNoteManagerProvider,
                          QuoteManagerProvider,
                          ProductManagerProvider,
                          ParamsManagerProvider,
                          CategoryManagerProvider,
                          CompanyParamsManagerProvider,
                          InvoiceParamsManagerProvider,
                          QuoteParamsManagerProvider,
                          CreditNoteParamsManagerProvider,
                          OrderParamsManagerProvider,
                          ProductParamsManagerProvider,
                          TagManagerProvider,
                          InvoiceTemplateManagerProvider,
                          DefaultInvoiceTemplateManagerProvider,
                          QuoteTemplateManagerProvider,
                          DefaultQuoteTemplateManagerProvider,
                          CreditNoteTemplateManagerProvider,
                          DefaultCreditNoteTemplateManagerProvider,
                          NotificationManagerProvider,
                          InmailManagerProvider,
                          BusinessContactManagerProvider,
                          BalanceManagerProvider,
                          AddressManagerProvider,
                          DashboardManagerProvider,
                          CardManagerProvider,
                          CustomFieldManagerProvider,
                          OrderManagerProvider,
                          VatManagerProvider,
                          ProductTypeManagerProvider,
                          NumberManagerProvider,
                          BpuManagerProvider,
                          InterventionManagerProvider,
                          EmailTemplateManagerProvider,
                          ChorusSettingManagerProvider,
                          ChorusMonitoringManagerProvider,
                          ChorusHistoryManagerProvider,
                          ProductPackManagerProvider
                        ) {
    EntityServiceProvider.setManager(EntityManagerProvider.$get())
    UserManagerProvider.setRootUrl(urls.api + '/zenlabs/users')
    EntityManagerProvider.setRootUrl(urls.api + '/crm/entities')
    InvoiceManagerProvider.setRootUrl(urls.api + '/kilo/invoices')
    CreditNoteManagerProvider.setRootUrl(urls.api + '/kilo/creditnotes')
    QuoteManagerProvider.setRootUrl(urls.api + '/kilo/quotes')
    ProductManagerProvider.setRootUrl(urls.api + '/kilo/products')
    TagManagerProvider.setRootUrl(urls.api + '/kilo/tags')
    ParamsManagerProvider.setRootUrl(urls.backend + '/api/params')
    CategoryManagerProvider.setRootUrl(urls.backend + '/api/categories')
    CompanyParamsManagerProvider.setRootUrl(urls.backend + '/api/companyparams')
    InvoiceParamsManagerProvider.setRootUrl(urls.backend + '/api/invoiceparams')
    QuoteParamsManagerProvider.setRootUrl(urls.backend + '/api/quoteparams')
    CreditNoteParamsManagerProvider.setRootUrl(urls.backend + '/api/creditnoteparams')
    OrderParamsManagerProvider.setRootUrl(urls.backend + '/api/orderparams')
    ProductParamsManagerProvider.setRootUrl(urls.backend + '/api/productparams')
    InvoiceTemplateManagerProvider.setRootUrl(urls.backend + '/api/invoicetemplates')
    DefaultInvoiceTemplateManagerProvider.setRootUrl(urls.backend + '/defaults/invoicetemplates')
    QuoteTemplateManagerProvider.setRootUrl(urls.backend + '/api/quotetemplates')
    DefaultQuoteTemplateManagerProvider.setRootUrl(urls.backend + '/defaults/quotetemplates')
    CreditNoteTemplateManagerProvider.setRootUrl(urls.backend + '/api/creditnotetemplates')
    DefaultCreditNoteTemplateManagerProvider.setRootUrl(urls.backend + '/defaults/creditnotetemplates')
    NotificationManagerProvider.setRootUrl(urls.api + '/zenlabs/notifications')
    InmailManagerProvider.setRootUrl(urls.api + '/kilo/inmails')
    BusinessContactManagerProvider.setRootUrl(urls.api + '/crm/businesscontacts')
    BalanceManagerProvider.setRootUrl(urls.api + '/kilo/balances')
    AddressManagerProvider.setRootUrl(urls.api + '/crm/addresses')
    DashboardManagerProvider.setRootUrl(urls.backend + '/api/dashboards')
    CardManagerProvider.setRootUrl(urls.backend + '/api/cards')
    CustomFieldManagerProvider.setRootUrl(urls.api + '/meta/customfields')
    OrderManagerProvider.setRootUrl(urls.api + '/kilo/orders')
    VatManagerProvider.setRootUrl(urls.api + '/trade/vats')
    ProductTypeManagerProvider.setRootUrl(urls.api + '/kilo/producttypes')
    NumberManagerProvider.setRootUrl(urls.api + '/kilo/numbers')
    BpuManagerProvider.setRootUrl(urls.api + '/kilo/bpus')
    InterventionManagerProvider.setRootUrl(urls.api + '/solica/interventions')
    EmailTemplateManagerProvider.setRootUrl(urls.backend + '/api/emailtemplates')
    ChorusSettingManagerProvider.setRootUrl(urls.backendChorus + '/settings')
    ChorusMonitoringManagerProvider.setRootUrl(urls.backendChorus + '/monitorings')
    ChorusHistoryManagerProvider.setRootUrl(urls.backendChorus + '/history')
    ProductPackManagerProvider.setRootUrl(urls.api + '/kilo/productpacks')
  }
})(window.angular)
